import { useQuery } from '@tanstack/react-query';

import { getAddressDetailsQuery } from '@/app/queries';

const useAddressDetails = <T>(
  key: string
): {
  data: T[];
  isFetching: boolean;
  status: 'error' | 'success' | 'pending';
} => {
  const addressListQuery = useQuery({
    queryKey: ['getAddressDetails', { key }],
    queryFn: getAddressDetailsQuery,
    enabled: Boolean(key),
    retry: false,
  });

  const { data } = addressListQuery as unknown as { data: T[] };

  return {
    data,
    isFetching: addressListQuery.isFetching,
    status: addressListQuery.status,
  };
};

export { useAddressDetails };
